import { OrganizationList } from "@clerk/clerk-react";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/select-org")({
  component: () => (
    <div className="min-h-dvh grid place-items-center bg-background p-6">
      <OrganizationList
        hidePersonal
        afterCreateOrganizationUrl="/sites"
        afterSelectOrganizationUrl="/sites"
      />
    </div>
  ),
});
